import { Box, Button, Checkbox, CheckboxGroup, Flex, FormControl, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalOverlay } from '@chakra-ui/react';
import HtmlToReact from 'html-to-react';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ReactSignatureCanvas from 'react-signature-canvas';
import { waiverEN, waiverID } from '../../../mock/waiver';

const HtmlToReactParser = HtmlToReact.Parser;
export default function ModalSignWaiver({ isOpen, onClose, onConfirm }) {
    const ref = useRef('');

    const { t, i18n } = useTranslation();

    const [signature, setSignature] = useState('');
    const [checkbox, setCheckbox] = useState([]);
    const [checkboxSubscribe, setCheckboxSubscribe] = useState('');

    const handleClose = () => {
        onClose();
        formik.handleReset();
    };

    const onEnd = () => {
        const sig = ref?.current?.getTrimmedCanvas().toDataURL('image/png');
        setSignature(sig);
    };

    const onChangeCheckbox = (e) => setCheckbox(e);
    const onChangeCheckBoxSubscribe = (e) => setCheckboxSubscribe(e?.target?.checked);

    const clear = () => {
        ref?.current?.clear();
        setSignature('');
    };

    const inputHtml = () => {
        let text;
        switch (i18n.language) {
            case 'id':
                text = waiverID;
                break;
            case 'en':
                text = waiverEN;
                break;
            default:
                text = '';
        }
        return text;
    };

    const htmlToReactParser = new HtmlToReactParser();
    const reactElement = htmlToReactParser.parse(inputHtml());

    return (
        <Modal isOpen={isOpen} onClose={handleClose} size='3xl' scrollBehavior='inside' isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalCloseButton />
                <ModalBody py={7}>
                    <FormControl>
                        <Box w='full' p={5}>
                            {reactElement}
                        </Box>
                        <Box p={5}>
                            <CheckboxGroup colorScheme='blue' defaultValue={checkbox} onChange={onChangeCheckbox}>
                                <Flex w='full' flexDirection='column' gap={3}>
                                    <Checkbox value='1' size='lg'>
                                        {t('disparity')}
                                    </Checkbox>
                                    <Checkbox value='2' size='lg'>
                                        {t('confirm')}
                                    </Checkbox>
                                    <Checkbox value={checkboxSubscribe} size='lg' defaultValue={checkboxSubscribe} defaultChecked onChange={onChangeCheckBoxSubscribe}>
                                        {t('subscribe')}
                                    </Checkbox>
                                </Flex>
                            </CheckboxGroup>
                        </Box>
                        <Box>
                            <ReactSignatureCanvas
                                backgroundColor='#EEEEEE'
                                penColor='black'
                                ref={ref}
                                onEnd={onEnd}
                                canvasProps={{
                                    width: 500,
                                    height: 400,
                                    className: 'sigCanvas',
                                }}
                            />

                            <Button onClick={clear} isDisabled={signature === ''} mt={3} colorScheme='red' px={7}>
                                {t('clear')}
                            </Button>
                        </Box>
                    </FormControl>
                </ModalBody>
                <ModalFooter gap={3}>
                    <Button variant='outline' colorScheme='red' mt={3} size='lg' fontSize='15px' onClick={handleClose}>
                        Cancel
                    </Button>
                    <Button
                        isDisabled={checkbox.length !== 2 || signature === ''}
                        variant='solid'
                        colorScheme='primary'
                        mt={3}
                        size='lg'
                        fontSize='15px'
                        onClick={() => {
                            handleClose();

                            if (typeof onConfirm === 'function') {
                                onConfirm(signature);
                            }
                        }}>
                        Confirm
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
}
